// extracted by mini-css-extract-plugin
module.exports = {"Search":"QuizzesPage_Search__1kC3S","Rule":"QuizzesPage_Rule__stoC1"};